module.exports = __webpack_public_path__ + "static/dashboard_screenshot_en-37cbd153cc168cc14d525f427c1a5867.png";